export default {
  title: 'Anfahrt',
  sections: {
    main: {
      fields: {
        value: {
          title: 'Anfahrt',
          subTitle: 'Ihr Weg zu uns',
          text: 'Unser Hauptsitz befindet sich im Bürogebäude «Wunderraum» an der Churerstrasse 34 in Pfäffikon SZ. Unsere Büroräumlichkeiten liegen nur drei Gehminuten vom Bahnhof Pfäffikon entfernt. Das Gebäude verfügt über eine eigene Tiefgarage, deren Einfahrt an der Huobstrasse liegt. Zusätzliche Parkmöglichkeiten finden Sie in der Tiefgarage Huob oder direkt beim Bahnhof Pfäffikon.',
          buttonLabel: 'WEGBESCHREIBUNG',
          buttonLink: 'https://www.google.com/maps?saddr=My+Location&daddr=47.20113,8.78043',
        },
      }
    }
  }
}
